export const constructTitle = (type) => {
  if (!type) return "Finishing Hourly";

  const titleMap = {
    iron: "Finishing Hourly Iron",
    fold: "Finishing Hourly Fold",
    poly: "Finishing Hourly Poly",
  };

  return titleMap[type.toLowerCase()] || "Finishing Hourly";
};
